export const PRODUCTS_UPDATE_PRODUCTS = 'PRODUCTS_UPDATE_PRODUCTS';
export const PRODUCTS_UPDATE_SLUG = 'PRODUCTS_UPDATE_SLUG';
export const PRODUCTS_UPDATE_CLICKED_PRODUCT = 'PRODUCTS_UPDATE_CLICKED_PRODUCT';
